<template>
<div class="element-box">
    <form autocomplete="off" @submit.prevent="salvar()">
      <div class="form-row">
        <div class="col form-group">
          <label for="name">Nome</label>
          <input required class="form-control" type="text" name="name" id="name" v-model="profissional.nome">
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
          <label for="tipoRegistro">Conselho Profissional</label>
          <select required v-model="profissional.tipoRegistro" name="tipoRegistro" id="tipoRegistro" class="custom-select">
            <option :value="null">Selecione</option>
            <option v-for="conselho in listaConselhoProfissional" :value="conselho.nome" :key="conselho._id" v-text="conselho.nome"></option>
          </select>
        </div>
        <div class="col form-group">
          <label for="name">Número</label>
          <input required class="form-control" type="text" name="numeroRegistro" id="numeroRegistro"
             v-model="profissional.numeroRegistro">
        </div>
      </div>
      <div class="form-row" v-if="rede.agendamento">
          <div class="col">
            <label for="tempoAtendimento">Tempo de atendimento</label>
            <label class="custom-control custom-radio custom-control-inline"
              v-for="tempoAtendimento in listTempoAtendimento" :key="tempoAtendimento.value">
              <input required v-model="profissional.tempoAtendimento" type="radio" name="tempoAtendimento" :id="`tmpAtendimento-${tempoAtendimento.value}`" 
                :value="tempoAtendimento.value" class="custom-control-input">
              <span class="custom-control-label" v-text="tempoAtendimento.descricao"></span>
            </label>
          </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
          <label for="especialidade">Especialidade</label>
            <select class="custom-select" 
              v-model="idEspecialidade"
              name="especialidade" id="especialidade">
              <option :value="null">Selecione</option>
              <option v-for="e in especialidades" :key="e.codigo" :value="e.codigo" v-text="e.nome"></option>
            </select>
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
          <label >Email</label>
          <input required type="email" name="email" id="email" class="form-control" 
            v-model="profissional.email">
        </div>
      </div>
      <div class="form-row" v-if="profissional && profissional._id">
        <div class="col">
          <div class="form-desc">
              Adicione o arquivo referente a sua Imagem de perfil
          </div>
          <vue-dropzone  id="drop1" :options="dropOptions"></vue-dropzone>
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
          <label for="miniBio">Currículo</label>
          <textarea v-model="profissional.miniBio" class="form-control" name="miniBio" id="miniBio" cols="30" rows="10"></textarea>
        </div>
      </div>
      <div class="col text-center">
        <button type="submit" class="btn btn-primary">Salvar</button>
      </div>
    </form>
</div>
</template>
<script>
import vueDropzone from 'vue2-dropzone'
import http from 'axios'

export default {
  components: {
    vueDropzone
  },
  computed: {
    rede () {
      return this.$store.getters.rede
    },
    isPF () {
      return this.$store.getters.rede && this.$store.getters.rede.cpf
    },
    utilizaAgendamento () {
      return this.$store.getters.rede && this.$store.getters.rede.agendamento
    }
  },
  mounted () {
    this.$store.dispatch('getTiposRegistro', '')
      .then((list) => {
        this.listaConselhoProfissional = list
      })
    this.$store.dispatch('listEspecialidadeRede', '')
      .then(especialidades => {
        this.especialidades = especialidades
      })
    if (this.$store.getters.corpoClinico) {
      this.profissional = this.$store.getters.corpoClinico
      this.idEspecialidade = this.profissional.especialidade._id
      this.dropOptions.url = `${http.defaults.baseURL}/corpoClinicoImagem/${this.$store.getters.corpoClinico._id}/logo`
    } else {
      this.profissional = {}
    }
  },
  data () {
    return {
      repetirSenha: null,
      dropOptions: {
        maxFilesize: 2, // MB
        maxFiles: 1,
        chunking: false,
        // chunkSize: 500, // Bytes
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        dictDefaultMessage: '<i class="fa fa-cloud-upload"></i>Arraste os arquivos aqui para enviar'
      },
      especialidades: [],
      listaConselhoProfissional: [],
      profissional: {
        nome: null,
        tipoRegistro: null,
        numeroRegistro: null,
        especialidade: null
      },
      idEspecialidade: null,
      listTempoAtendimento: [
        {value: 20, descricao: '20 min'},
        {value: 30, descricao: '30 min'},
        {value: 60, descricao: '1 h'}
      ]
    }
  },
  methods: {
    salvar () {
      this.profissional.rede = this.$store.getters.rede
      this.profissional.especialidade = this.idEspecialidade

      if (this.profissional._id) {
        this.profissional.tempoAtendimento = this.profissional.tempoAtendimento ? this.profissional.tempoAtendimento : 0
      }
      this.$store.dispatch('saveCorpoClinico', this.profissional)
        .then(() => {
          this.$store.dispatch('setCorpoClinico')

          if (this.$store.getters.user.role === 'CorpoClinico') {
            this.$router.push({name: 'HomeAdmin'})
          } else {
            if (this.utilizaAgendamento) {
              this.$toasted.info('Cadastro realizado com sucesso! Porém é necessário realizar a configuração da agenda do Profissional!')
            }
            this.$router.push({name: 'PageCadastroProfissionalList'})
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cadastroProfissional/Form.vue